module.exports = __webpack_public_path__ + "static/banner-mb-03-1984db5b9fa26e30bde4b4be7a81b3c1.jpg";